import { cn } from "@/shared/lib/cn";

type ProfileAvatarProps = {
  initials: string;
  size?: number;
  className?: string;
  variant?: "default" | "sidebar";
};

export function ProfileAvatar({
  initials,
  size = 44,
  className,
  variant = "default",
}: ProfileAvatarProps) {
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-semibold uppercase tracking-wide",
        variant === "sidebar"
          ? "bg-accent text-accent-foreground"
          : "bg-primary text-primary-foreground",
        className,
      )}
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.32)) }}
      aria-hidden
    >
      {initials}
    </div>
  );
}
